/**
 * @author WYX
 * @date 2019/12/26
 * @Description: 稿件报题关联指令模块
 */
angular.module('editPageLinkModule', []).directive('editPageLink', [
    function() {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageLink/editPageLink.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        // 判断是否有报题选题
                        selectedReport: null,
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {

                }
            },
        };
    },
]);
